

export interface InitiateLoginOptions {
    shopId: string;
    clientId: string;
}

export const shopifyAuthOptions: InitiateLoginOptions = {
    shopId: process.env.GATSBY_SHOPIFY_SHOP_ID!,
    clientId: process.env.GATSBY_SHOPIFY_CUSTOMERACCOUNTSAPI_CLIENTID!,
}

export const getRedirectUrl = (path: string) => {
    return `https://${window.location.hostname}${window.location.port !== '443' && window.location.port !== '' ? (':' + window.location.port) : ''}${path}`;
}

